import * as React from 'react';
import { Route } from 'react-router-dom';
import '@livekit/components-styles';
import { DisplayToast } from 'gossamer-front-end';
import { HostLivestreamPage } from './HostLivestreamPage';
import ViewerLivestream from './ViewerLivestream';

const LivestreamRouteFrame = ({ children }: React.PropsWithChildren): React.JSX.Element => (
  <>
    <DisplayToast />
    {children}
  </>
);

export const getLivestreamRoutes = (): React.ReactNode => (
  <>
    <Route
      path="/view/:roomId"
      element={
        <LivestreamRouteFrame>
          <ViewerLivestream />
        </LivestreamRouteFrame>
      }
    />
    <Route
      path="/host/:roomId"
      element={
        <LivestreamRouteFrame>
          <HostLivestreamPage />
        </LivestreamRouteFrame>
      }
    />
    <Route
      path="/host/:roomId/preview"
      element={
        <LivestreamRouteFrame>
          <HostLivestreamPage />
        </LivestreamRouteFrame>
      }
    />
  </>
);

export const getWebsiteLivestreamRoutes = (): React.ReactNode => (
  <>
    <Route path="livestream-attendee/:roomId" element={<ViewerLivestream />} />
    <Route path="live/:roomId" element={<ViewerLivestream />} />
    <Route path="livestream-host/:roomId" element={<HostLivestreamPage />} />
    <Route path="livestream-host/:roomId/preview" element={<HostLivestreamPage />} />
    <Route path="host-live/:roomId" element={<HostLivestreamPage />} />
    <Route path="host-live/:roomId/preview" element={<HostLivestreamPage />} />
  </>
);
